// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import ForerunnerDB from "forerunnerdb";

export class FilterSearch {
  fore_runner_db: object
  database: object
  containers: NodeListOf<HTMLElement>

  constructor() {
    this.fore_runner_db = new ForerunnerDB()
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    this.database = this.fore_runner_db.db()
    this.containers = document.querySelectorAll<HTMLElement>('[data-filter-search="container"]')
  }

  build_collection(json: any) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const collection =  this.database.collection()

    json.data.map((data: any) => {
      collection.insert([{
        ...data,
      }])
    })

    return collection
  }

  valid_json(search: HTMLElement) {
    const json = JSON.parse(search.querySelector<HTMLElement>('[data-filter-search="json"]').innerHTML)

    if (json.list && json.filter && json.data && json.translations)
    {return json}

    const hideInput: HTMLElement = document.querySelector('[data-filter-search="input-label"]')
    hideInput.style.display = "none"

    return false
  }

  calculate_container(json: any, list: HTMLElement) {
    const items = list.querySelectorAll('[data-filter-search="item"]')
    let tallestElement = 0

    const columns = Number(json.list.columns)
    const show = Number(json.list.items_to_show);

    [].forEach.call(items, (item: HTMLElement, index: number) => {
      if (index < show) {return false}

      tallestElement
        = tallestElement < (<HTMLElement>item).offsetHeight ? (<HTMLElement>item).offsetHeight : tallestElement
    })

    list.style.maxHeight = `${(show / columns) * tallestElement}px`
  }

  message(result: any, list: HTMLElement, json: any) {
    const messages = document.querySelectorAll(".empty-message");
    [].forEach.call(messages, (message: { remove: () => void; }) => {
      message.remove()
    })

    if (result.length < 1) {
      const element = document.createElement("div")
      element.setAttribute("class", "col-xs-12 empty-message")
      element.innerHTML = `<strong>${json.translations.empty}</strong>`

      list.append(element)
    }
  }

  filter(list: HTMLElement, items: NodeListOf<Element>, result: any) {
    [].forEach.call(items, (item: HTMLInputElement) => (<HTMLInputElement>item).style.display = "none")

    result.map((result: { id: bigint; }) => {
      const item = list.querySelector(`[data-filter-search="item"][data-filter-id="${result.id}"]`)

      item.removeAttribute("style")
    })
  }

  search(json: any, value: any, list: HTMLElement, collection: any) {
    const search_terms = value.split(" ")
    const items = list.querySelectorAll('[data-filter-search="item"]')
    const build: { [x: string]: RegExp | { [x: string]: RegExp; }; }[] = []

    const regexes: RegExp[] = []
    for (const term of search_terms) {
      regexes.push(new RegExp(`^(.*?(${term})[^$]*)`, "i"))
    }

    [].forEach.call(Object.keys(json.filter), (key:string) => {
      const type = json.filter[key]

      for (const term of regexes) {
        build.push({ [key]: term });

        [].forEach.call(type, (filter: string) => {
          build.push({ [key]: {
            [filter]: term,
          } })
        })
      }
    })

    const result = collection.find({
      $or: build,
    })

    this.message(result, list, json)
    this.filter(list, items, result)
  }

  init() {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    [...this.containers].map(search => {
      const json = this.valid_json(search)

      search.classList.add("search-initialized")

      if (!json)
      {return false}

      const collection = this.build_collection(json)

      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      const input = search.querySelector<HTMLInputElement>('[data-filter-search="input"]')

      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      const submit = search.querySelector<HTMLElement>('[data-filter-search="submit"]')

      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      const list = search.querySelector<HTMLElement>('[data-filter-search="list"]')

      this.calculate_container(json, list)

      submit.addEventListener("click", (event: { preventDefault: () => void; }) => {
        event.preventDefault()

        this.search(json, input.value, list, collection)
      })

      input.addEventListener("keyup", (event: { target: HTMLFormElement; }) => {
        this.search(json, (<HTMLFormElement>event.target).value, list, collection)
      })
    })
  }
}
